// url-tracker.service.ts
import { Injectable } from '@angular/core';
import { Router, NavigationEnd, Event } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UrlTrackerService {
  private currentUrl = new BehaviorSubject<string>('');
  currentUrl$ = this.currentUrl.asObservable();

  constructor(private router: Router) {
    this.router.events
      .pipe(
        filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd) // Type guard to assert NavigationEnd
      )
      .subscribe((event: NavigationEnd) => {
        this.currentUrl.next(event.urlAfterRedirects);
      });
  }

  getCurrentUrl(): string {
    return this.currentUrl.getValue();
  }
}
